import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const rewardSalesRoutes = [
	{
		key: "reward-sales-action-center",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/sales/action-center`,
		component: React.lazy(() => import("views/reward-views/sales/action-center/pages/SalesActionCenter")),
	},
	{
		key: "reward-order-list",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/order/list`,
		component: React.lazy(() => import("views/reward-views/sales/sales-orders/pages/OrderList")),
	},
	{
		key: "reward-order-all-regions",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/order/all-regions`,
		component: React.lazy(() => import("views/reward-views/sales/sales-orders/pages/AllDistributionOrders")),
	},
	{
		key: "reward-orelbuy-order-list",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/orelbuy/order/list`,
		component: React.lazy(() => import("views/reward-views/sales/orelbuy-orders/pages/OrelBuyOrderList")),
	},
	{
		key: "reward-orelbuy-order-detail",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/orelbuy/order/detail/:id`,
		component: React.lazy(() => import("views/reward-views/sales/orelbuy-orders/pages/OrelBuyOrderDetail")),
	},
	{
		key: "reward-order-tickets",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/order/tickets`,
		component: React.lazy(() => import("views/reward-views/sales/tickets/pages/Tickets")),
	},
	{
		key: "reward-order-detail",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/order/detail/:id`,
		component: React.lazy(() => import("views/reward-views/sales/sales-orders/pages/OrderDetail")),
	},
	{
		key: "reward-order-invoices",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/order/invoices`,
		component: React.lazy(() => import("views/reward-views/sales/invoices/pages/InvoiceList")),
	},
	{
		key: "reward-order-invoice-detail",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/order/invoices/:id`,
		component: React.lazy(() => import("views/reward-views/sales/invoices/pages/InvoiceDetail")),
	},
];
